/* eslint-disable camelcase */
import { AD_CREATION_TEXTS } from '../ad-creation/ad-creation.constants';

export const oneClickInsightCardValidation = (cardSelected: any): boolean => {
    const { custom_data } = cardSelected;

    const { accordion } = custom_data;

    if (!accordion) {
        return true;
    }

    const { items, inputs_validation } = accordion;

    const erroValidation = inputs_validation?.error_description
        || AD_CREATION_TEXTS.FORM_ERROR;

    items.forEach((item) => {
        Object.keys(item)
            .filter(key => typeof item[key] === 'object')
            .forEach((key) => {
                const { regexValidator } = item[key];
                const { content } = item[key];
                const regex = new RegExp(regexValidator);
                const inputIsValid = regex?.test(content);

                if (!inputIsValid) throw new Error(erroValidation);
            });
    });

    const numEditableFields = items.reduce(
        (acc, subitem: any) => (acc + Object.values(subitem).reduce(
            (acc2: number, subitemValue: any) => acc2 + (
                    subitemValue?.isEditable === true ? 1 : 0
            ), 0,
        )), 0,
    );

    const invalidFields = items.reduce(
        (acc, subitem: any) => (acc + Object.values(subitem).reduce(
            (acc2: number, subitemValue: any) => acc2 + (
                    subitemValue?.inputIsValid === false ? 1 : 0
            ), 0,
        )), 0,
    );

    const minValidInputs = inputs_validation?.min_valid_inputs || numEditableFields;

    if ((numEditableFields - invalidFields) < minValidInputs) throw new Error(erroValidation);

    return true;
};
